import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-900" role="contentinfo">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-bold font-heading text-background-50 whitespace-nowrap">
                韩漫画网
              </span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              韩漫画网致力于为广大漫画爱好者提供优质的韩国漫画在线阅读服务。海量资源、每日更新、完全免费。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              漫画分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(1, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-background-50 transition-colors duration-150 whitespace-nowrap"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-300 hover:text-background-50 transition-colors duration-150 whitespace-nowrap"
                >
                  网站首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/all"
                  className="text-sm text-background-300 hover:text-background-50 transition-colors duration-150 whitespace-nowrap"
                >
                  全部分类
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-300 hover:text-background-50 transition-colors duration-150 whitespace-nowrap"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-mail-line text-background-400"></i>
                <span>contact@hanmanhua.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-time-line text-background-400"></i>
                <span>每日更新 全年无休</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; {new Date().getFullYear()} 韩漫画网 - 免费在线观看韩国漫画 | 好看的韩漫大全
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors duration-150 whitespace-nowrap">服务条款</a>
              <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors duration-150 whitespace-nowrap">隐私政策</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}